// import React from 'react';
// import { useSelector } from 'react-redux';
// import { Navigate, Outlet } from 'react-router-dom';

// const ProtectedRoute = () => {
//   const { isAuthenticated } = useSelector((state) => state.auth);

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { logout } from '../features/Auth/authSlice'; // Import your logout action

const ProtectedRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Check if the token is expired (you can add additional logic here)
    const token = localStorage.getItem('accessToken');
    if (!token && isAuthenticated) {
      dispatch(logout()); // Dispatch logout to clear the state
    }
  }, [isAuthenticated, dispatch]);

  if (!isAuthenticated) {
    // Redirect to login with a session_expired message if coming from a protected route
    return <Navigate to="/login?message=session_expired" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;